<script setup lang="ts">
import {computed, defineProps, onMounted, ref, defineEmits, watch, getCurrentInstance} from "vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";

const props = defineProps({
  value: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
})

const instance = ref(null)

onMounted(() => {
  instance.value = getCurrentInstance()
})

const emits = defineEmits(['input', 'selected'])

const isSelectDisabled = computed(() => {
  return props.disabled;
})

const options = computed(() => {
  const $i18n = instance.value?.proxy?.$i18n;
  // console.log('instance 1', instance.value?.proxy?.$i18n.messages, instance.value?.proxy?.$i18n.t('ID Card'))
  return [
    {title: 'ID Card', value: '1'},
    {title: 'Passport', value: '2'},
  ].map((option) => {
    return {
      value: option.value,
      title: $i18n ? $i18n.t(option.title) : option.title,
    }
  })
})

const val = computed({
  get: () => props.value,
  set: (value) => emits('input', value)
})

const selectedOption = computed(() => {
  if (!val.value) return null;
  return options.value.find((option) => option.value === val.value);
})

watch(selectedOption, (v) => {
  emits('selected', v)
})
</script>

<template>
  <PrimeDropdown :filterPlaceholder="$t('Поиск...')"
                 :emptyFilterMessage="$t('Ничего не найдено')"
                 optionLabel="title"
                 optionValue="value"
                 :disabled="isSelectDisabled"
                 dataKey="code"
                 :placeholder="$t('Выберите тип документа...')"
                 :options="options"
                 v-model="val">
  </PrimeDropdown>
</template>

<style scoped lang="less">

</style>

<i18n src="capitalist-shared/src/finance/locales/ru/payout.json" locale="ru"></i18n>
<i18n src="capitalist-shared/src/finance/locales/en/payout.json" locale="en"></i18n>
